import React from 'react'
import { backgroundBarGraph, healthCheckMale, lineGraph, mentalWellness, yogaGirl } from '../../../assets/images'
import { Divider, Heading, MetricCard } from '../../common/atoms'
import { OverviewSectionIcon } from '../../overview/OverviewSectionIcon'
import { RoundedSelect } from '../../tailwind/atoms'
import Highstock from 'highcharts/highstock';
import ReactHighcharts from 'react-highcharts';
import { withDsChartTheme } from './../../../utils/chartTheme';
import { GraphHoverData } from '../../tailwind/molecules'
import { HorizontalBarGraph, StepathonUtilization } from '../../tailwind/organisms'
const Charts = withDsChartTheme(ReactHighcharts.withHighcharts(Highstock));
import Skeleton from 'react-loading-skeleton';


const MentalWellnessEWAP = ({selectedItem1 , barGraphData,  basicConfigValues , lineGraphPresent , barGraphPresent, metricObj , lineGraphData,selectedItem2, selectedOptions  , selectedContractId = '', changeContractTo, loading  }) => {

  const renderLineGraph  = () =>{
    let a  = selectedItem2 ==='Last 30 Days' ? 'last_30days' : 'contract_period'
    let data = lineGraphData?.[a] ?? {}
    let totalSum = a === 'last_30days' ? (lineGraphData?.['last_30days'] ?? [])?.map((item) => item[1]).reduce((a,v) =>  a = a + v, 0 ) : Object.values(lineGraphData?.['contract_period'] ?? {}).reduce((a,v) =>  a = a + v, 0 )
    if (totalSum > 0){
      if(selectedItem2 === 'Last 30 Days'){
        return(
          <div>
            {renderDaysChart(data)}
          </div>
        )
      }else{
        return(
          <div>
            {renderChart(data)}
          </div>
        )
      }
    }
    else{
      return(
        <div>
        {lineGraphNoData()}
        </div>
      )
    }
  }

  const renderBarGraph = (record) => {
    let totalSum = Object.values(record?.['data'] ?? {})?.map((item) => item?.['employees_affected']).reduce((a,v) =>  a = a + v , 0 )

    if (totalSum > 0){
      let keys = barGraphData?.barLabels_barColors?.labels
      let baseConfig = _.cloneDeep(basicConfigValues)
      const series  = barGraphData?.barData
      baseConfig.config.chart = {
        type: 'bar',
        events: {
          load: function() {
            let categoryHeight = 60;
            this.update({
              chart: {
                height: categoryHeight * this.pointCount + (this.chartHeight - this.plotHeight)
              }
            })
          }
        }
      },

      baseConfig.config.xAxis= {
          categories: keys,
          startOnTick : true,
          endOnTick: true,
          tickLength: 0,
          labels: {
            align :'right',
            offset : 10,
            style: {
              color : '#9CA3AF',
              fontFamily: 'Inter',
              fontSize: '1.2em',
              fontWeight : 600
            }
          },
        },

      baseConfig.config.yAxis= {
        min: 0,
        max: 100,
        width: '95%',
        visible: true,
        lineWidth: 1,
        gridLineDashStyle: 'longdash',
        endOnTick: true,
        maxPadding: 10,
        overflow: 'justify',
        title: {
          text: null
        },
        labels : {
          enabled: true,
          format: '{value}%',
          style: {
            color : '#9CA3AF',
            fontFamily: 'Inter',
            fontSize: '12px',
            fontWeight : 400
          }
        },
      },
      baseConfig.config.plotOptions= {
          series: {
              colorByPoint: true,

              dataSorting: {
                enabled: true,
                matchByName: true
              }
          },
          bar: {
            dataLabels: {
              enabled: true,
              formatter: function() {
                return "<div style='font-size:16px;color:#9CA3AF;font-weight:600'>" + this.point.y + '%' + '</div>'
              }
            }
          }
      },

      baseConfig.config.series= [{
          data: series,
          showInLegend :false,
          pointWidth : 40

      }]

      baseConfig.config.tooltip = {
        shared: true,
        useHTML: true,
        borderRadius: 8,
        borderWidth: 1,
        borderColor:'#E5E8F0',
        backgroundColor: '#FFFFFF',
        padding: 12,
        shape: 'rect',
        formatter: function() {

          return "<div style='min-width: 220px;height:65px;display:flex;flex-direction:row;'>" + `<div style=width:5px;height:65px;background-color:${this.points[0].color};border-radius:10px;></div>` + '<div style="padding-left:12px;"><span style="font-size:16px;color:#6B7280;font-weight:600;margin-bottom:0px;">'
          + this.points[0].key + '</span></p>' + '<p style="margin-top:6px"><span style="font-size:16px;color:#4B5563;font-weight:600;padding: 4px 2px;background-color:#F9FAFB;border-radius:3px">' +  barGraphData?.data?.[this.points[0].key]?.overall+ '%' +'</span>' + '<span style="font-size:14px;color:#6B7280;font-weight:500;padding-left:2px;border-radius:3px;">'
          + 'Overall' + '</span></p></div></div>'
        }
      }

      return(
        <div className='mt-6 p-6'>
          <Charts config={baseConfig.config}/>
          <h1 className='w-full align-baseline text-left text-sm leading-3 text-gray-500 mt-4'>Number of employees who took counselling sessions in the selected period: <span className='font-semibold text-sm '>{barGraphData?.total}</span></h1>
        </div>
      )
    }
    else{
      return (
        barGraphNoData()
      )
    }
  }


  const renderDaysChart = (record) => {
    let baseConfig = _.cloneDeep(basicConfigValues)
    let series = Object.values(record)
    baseConfig.config.chart.type = 'line'
    baseConfig.config.xAxis = {type: 'datetime',
                              dateTimeLabelFormats: {
                                  month: '%d. %b',
                                  year: '%b'
                                },
                                title: {
                                  text: 'Days',
                                  offset : 25,
                                  style: {
                                    color : '#4B5563',
                                    fontFamily: 'monospace',
                                    fontSize: '1.2em',
                                    fontWeight : 600
                                  }
                                },
                              }

    baseConfig.config.tooltip = {
                                shared: true,
                                useHTML: true,
                                borderRadius: 8,
                                borderWidth: 1,
                                borderColor:'#E5E8F0',
                                backgroundColor: '#FFFFFF',
                                dateTimeLabelFormats: {
                                  month: '%d. %b',
                                  year: '%b'
                                },
                                padding: 12,
                                shape: 'rect',
                                formatter: function() {
                                  return "<div style='width:208px;height:78px;display:flex;flex-direction:row;'>" +  "<div style='width:5px;height:74px;background-color:#2563EB;border-radius:10px'></div>"
                                  +  '<div style="padding-left:12px;"><span style="font-size:16px;color:#6B7280;font-weight:600;">' + 'Counselling sessions'
                                  + '</span><br/><span style="font-size:12px;color:#6B7280;font-weight:500;">' + Highstock.dateFormat('%d %b, %Y', this.x) + '</span>'
                                  + '<br><p style="padding-top:16px"><span style="font-size:16px;color:#4B5563;font-weight:600;">' + this.points[0].y + '</span>' + '<span style="font-size:14px;color:#6B7280;font-weight:500;">'
                                  + ' session taken' + '</span></p></div></div>'
                                }
                              }

    baseConfig.config.yAxis=  { visible: true,
                                lineWidth: 1,
                                gridLineDashStyle: 'longdash',
                                title :{
                                    text: "Counselling sessions",
                                    offset : 40,
                                    style: {
                                      color : '#4B5563',
                                      fontFamily: 'monospace',
                                      fontSize: '1.2em',
                                      fontWeight : 600
                                    }
                                  }
                              }

    baseConfig.config.yAxis.allowDecimals = false
    baseConfig.config.plotOptions = {line: { marker: {enabled: false}, dataLabels: { enabled: false}, enableMouseTracking: true,events: {
      legendItemClick: function () {
          return false;
      }
    }}}
    baseConfig.config.series = [{ showInLegend :false, data: series, color: '#2563EB'}]
    return(
      <div className='mt-6 p-6 bg-white'>
        <Charts
          config={baseConfig.config}
          />
      </div>
    )
  }

  const barGraphNoData = () => {
    return(
      <div className='ml-10 bg-contain w-auto' style={{ background: `url(${backgroundBarGraph})`, backgroundRepeat:"no-repeat", backgroundPosition: 'center', height: 446 }}>
        <StepathonUtilization icon={mentalWellness} label='No data available' classes='h-96' imgClasses='h-36 w-36 mt-14' labelClasses='text-xl font-semibold text-gray-700' titleClasses='text-gray-600'/>
      </div>
    )
  }

  const lineGraphNoData = () => {
    return(
      <div className='bg-contain w-auto h-96 mt-6' style={{ background: `url(${lineGraph})`, backgroundColor: 'white', backgroundRepeat:"no-repeat", backgroundPosition: 'center'}}>
        <StepathonUtilization icon={mentalWellness} label='No data available' classes='h-96' imgClasses='h-36 w-36 mt-4' labelClasses='text-xl font-semibold text-gray-700' titleClasses='text-gray-600'/>
      </div>
    )
  }

  const renderChart = (record) => {
    let keys = Object.keys(record)
    let baseConfig = _.cloneDeep(basicConfigValues)
    let series = Object.values(record)
    baseConfig.config.chart.type = 'line'
      baseConfig.config.yAxis = {   visible: true,
                                    lineWidth: 1,
                                    gridLineDashStyle: 'longdash',
                                    title : {text: "Counselling sessions",
                                        offset : 40,
                                        style: {
                                          color : '#4B5563',
                                          fontFamily: 'monospace',
                                          fontSize: '1.2em',
                                          fontWeight : 600
                                        }
                                      }
                                    }
  baseConfig.config.yAxis.allowDecimals = false
    baseConfig.config.xAxis = { categories: keys,
                                title: {
                                  text: 'Months',
                                  offset : 25,
                                  style: {
                                    color : '#4B5563',
                                    fontFamily: 'monospace',
                                    fontSize: '1.2em',
                                    fontWeight : 600
                                  }
                                }
                              }
    baseConfig.config.plotOptions = {line: { marker: {enabled: false}, dataLabels: { enabled: false}, enableMouseTracking: true,events: {
            legendItemClick: function () {
                return false;
            }
        }}}
    baseConfig.config.tooltip = {
      shared: true,
      useHTML: true,
      borderRadius: 8,
      borderWidth: 1,
      borderColor:'#E5E8F0',
      backgroundColor: '#FFFFFF',
      padding: 12,
      shape: 'rect',
      formatter: function() {
        return "<div style='width:208px;height:78px;display:flex;flex-direction:row;'>" +  "<div style='width:5px;height:74px;background-color:#2563EB;border-radius:10px'></div>"   + '<div style="padding-left:12px"><span style="font-size:16px;color:#6B7280;font-weight:600;margin-bottom:12px">'
        + 'Counselling sessions' + '</span><br/><span style="font-size:12px;color:#6B7280;font-weight:500;">' + this.points[0].key + '</span><br>' + '<p style="padding-top:16px"><span style="font-size:16px;color:#4B5563;font-weight:600;padding-top:30px;">' + this.points[0].y + '</span>'
        + '<span style="font-size:14px;color:#6B7280;font-weight:500;">' + ' session taken' + '</span></p></div></div>'
      }
    }

    baseConfig.config.series = [{showInLegend :false,  data: series.map(Number), color: '#2563EB'  }]
    return(
      <div className='mt-6 p-6 bg-white'>
        <Charts
          config={baseConfig.config} />
      </div>
    )
  }


  return (
    <div>
      <div className='mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2'>
        <MetricCard
          icon={<OverviewSectionIcon name='metric_employees_utilized' />}
          loading={loading}
          loaderHeight={178}
          title='Employees who availed counselling'
          titleClasses='text-sm font-semibold text-gray-900'
          subTitle='Total number of employees who booked a session and completed it'
          subTitleClasses='mt-1 text-xs leading-relaxed text-gray-600'
          metricValue={<span className='font-jetbrains-mono text-3xl font-semibold tabular-nums text-gray-900'>{metricObj?.employee_utilization_count || 0}</span>}
          metricValueSuffix={<span className='font-sans text-xs text-gray-700'>Employees</span>}
          metricClasses='mt-5 flex flex-col items-start gap-2 text-gray-700'
          classes='min-h-[178px] rounded-lg border-gray-300 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-400 hover:shadow-md'
        />
        <MetricCard
          icon={<OverviewSectionIcon name='hra' />}
          loading={loading}
          loaderHeight={178}
          title='Number of sessions'
          titleClasses='text-sm font-semibold text-gray-900'
          subTitle='Total number of counselling sessions completed by your employees'
          subTitleClasses='mt-1 text-xs leading-relaxed text-gray-600'
          metricValue={<span className='font-jetbrains-mono text-3xl font-semibold tabular-nums text-gray-900'>{metricObj?.total_eap_session_count || 0}</span>}
          metricValueSuffix={<span className='font-sans text-xs text-gray-700'>Sessions</span>}
          metricClasses='mt-5 flex flex-col items-start gap-2 text-gray-700'
          classes='min-h-[178px] rounded-lg border-gray-300 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-400 hover:shadow-md'
        />
      </div>
        <div className='flex flex-row justify-between mt-8 -mb-3'>
          <Heading mainHeading='COUNSELLING REASONS' mainClasses='text-xs font-semibold leading-snug text-gray-500 tracking-[0.12em]' subHeading='Counselling Reasons breakup for all availed sessions' subClasses='mt-1.5 text-sm leading-relaxed text-gray-500' />
          <RoundedSelect
            listClasses='w-44'
            selectOptions={selectedOptions}
            selectValues={[0,1]}
            curvalue={selectedItem1}
            selectHandler={(e) => selectedOptions?.length > 1 && changeContractTo({id: e, val : 'first'})}
          />
        </div>
        <div className='bg-white'>
           { loading ?
          <div className='mt-6'>
            <Skeleton width='100%' height={400} />
          </div>
          :
            <div className='mt-6'>
              {renderBarGraph(barGraphData)}
            </div>
          }
        </div>
        <div className='flex flex-row justify-between mt-8 w-full -mb-3'>
          <Heading mainHeading='MENTAL HEALTH TRENDS' mainClasses='text-xs font-semibold leading-snug text-gray-500 tracking-[0.12em]' subHeading='Trends based on the total number of counselling sessions completed' subClasses='mt-1.5 text-sm leading-relaxed text-gray-500' />
          <RoundedSelect
            listClasses='w-44'
            selectOptions={selectedOptions}
            selectValues={[2,3]}
            curvalue={selectedItem2}
            selectHandler={(e) => selectedOptions?.length > 1 && changeContractTo({id : e, val: 'second'})}
          />
        </div>
        <div>
          { loading ?
          <div className='mt-6'>
            <Skeleton width='100%' height={400} />
          </div>
          :
          <div className='mt-6'>
            {renderLineGraph(barGraphData)}
          </div>
          }
        </div>
    </div>
  )
}

export default MentalWellnessEWAP